import {
  ApiAddEmployeeDiscountCodesRequestedAction,
  apiAddEmployeeDiscountCodesFailed,
  apiAddEmployeeDiscountCodesSucceeded
} from '@spa/lib/store/api/cart/addEmployeeDiscountCodeApi';
import addEmployeeDiscountCodesAction, {
  AddEmployeeDiscountCodesActionInput,
  AddEmployeeDiscountCodesActionResult
} from '@spa/lib/actions/cart/addEmployeeDiscountCodesAction';
import { call, put } from 'typed-redux-saga';
import { ApplyEmployeeDiscountResult } from '@spa/generated/graphql/graphql';

function* addEmployeeDiscountCodesSaga({
  payload: { customOrderType, parentActionId, actionId: requestedActionId }
}: ApiAddEmployeeDiscountCodesRequestedAction): Generator {
  try {
    const input: AddEmployeeDiscountCodesActionInput = { customOrderType };
    const { cartId, result }: AddEmployeeDiscountCodesActionResult = yield* call(
      addEmployeeDiscountCodesAction,
      'addEmployeeDiscountCodesAction',
      input
    );

    yield* put(
      apiAddEmployeeDiscountCodesSucceeded({
        requestedActionId,
        parentActionId,
        result: result as unknown as ApplyEmployeeDiscountResult,
        cartId
      })
    );
  } catch {
    yield* put(
      apiAddEmployeeDiscountCodesFailed({
        requestedActionId,
        parentActionId
      })
    );
  }
}

export default addEmployeeDiscountCodesSaga;
